import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-typed-confirm-modal',
  standalone: false, // eslint-disable-line @angular-eslint/prefer-standalone
  templateUrl: './typed-confirm-modal.component.html',
})
export class TypedConfirmModalComponent {
  confirmationText = '';
  modal: NgbActiveModal;

  readonly requiredText = input('');
  readonly requiredTextValue = signal('');
  readonly text = input('');
  readonly textValue = signal('');
  readonly title = input('');
  readonly titleValue = signal('');

  constructor() {
    this.modal = inject(NgbActiveModal);
  }

  public canConfirm(): boolean {
    return this.confirmationText === this.resolvedRequiredText();
  }

  public confirm(): void {
    if (!this.canConfirm()) {
      return;
    }

    this.modal.close(true);
  }

  public resolvedRequiredText(): string {
    return this.requiredTextValue() || this.requiredText();
  }

  public resolvedText(): string {
    return this.textValue() || this.text();
  }

  public resolvedTitle(): string {
    return this.titleValue() || this.title();
  }

  public setContent(title: string, text: string, requiredText: string): void {
    this.titleValue.set(title);
    this.textValue.set(text);
    this.requiredTextValue.set(requiredText);
  }
}
